import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: ${({ theme }) => theme.palette.background.default};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
  padding: ${({ theme }) => `${theme.spacing(6)} 0 0`};

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.sm)} {
    flex-direction: row;
    padding: ${({ theme }) => `${theme.spacing(6)} ${theme.spacing(10)}`};
  }
`;

export const UspsContainer = styled.div``;

export const WidthRef = styled.div`
  width: 100%;
`;

export const UspList = styled.ul<{ $twoColumns: boolean; $noPadding: boolean }>`
  flex: 1;
  display: grid;
  grid-template-columns: ${({ $twoColumns }) =>
    $twoColumns ? 'repeat(2, 1fr)' : '1fr'};
  grid-row-gap: ${({ theme }) => theme.spacing(4)};
  grid-column-gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  padding: ${({ theme, $noPadding }) =>
    `0 ${$noPadding ? 0 : theme.spacing(6)}`};

  list-style: none;

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.sm)} {
    flex: 1;
    padding: 0;
  }
`;

export const UspListItem = styled.li`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  min-width: 0;
`;

export const UspListItemIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 2rem;
  width: 2rem;
  min-height: 2rem;
  height: 2rem;

  background: ${({ theme }) => theme.palette.grey[200]};
  border-radius: 50%;

  font-size: 1.2rem;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const UspTitleContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(0.5)};
  align-items: center;
  min-width: 0;
`;

export const UspTitle = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UspTooltipIconContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const PaymentForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;

  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  padding: ${({ theme }) => theme.spacing(4)};

  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.background.default};
  box-shadow: ${({ theme }) =>
    `0 ${theme.spacing(-1)} ${theme.spacing(4)} ${theme.spacing(-1.5)} ${rgba(theme.palette.common.black, 0.08)}`};

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.sm)} {
    flex: 1;
    position: initial;
    bottom: initial;
    left: initial;
    right: initial;

    border-top: none;
    box-shadow: none;
  }
`;

export const PaymentOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.sm)} {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;

export const Interactions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;

export const Disclaimer = styled.span<{ $hidden: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  ${({ $hidden }) =>
    $hidden &&
    css`
      opacity: 0;
    `};
`;
